'use strict';

import React, { Component } from 'react';

class sendTranscript extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (

    <svg className="sendTranscript" width="14px" height="14px" viewBox="0 0 14 14" onClick={this.props.onSendTranscript} >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g>
          <g transform="translate(1.500000, 0.500000)">
            <g transform="translate(0.000000, 4.000000)" stroke="currentColor" strokeWidth="0.7">
              <polyline points="7.43937709 0 11 0 11 7 0 7 0 0 3.56062291 0" />
              <polyline points="6.99888765 3.30653266 10.8898776 6.90619765 0.134593993 6.90619765 4.01334816 3.30653266" />
              <polyline points="7.43937709 0 10.865406 0 5.50611791 4.56113903 0.110122358 0.0820770519 3.53615128 0.0820770519" />
            </g>
            <polygon stroke="currentColor" strokeWidth="0.7" points="5.50612245 6 7 3.12866817 6.31428571 3.12866817 6.31428571 0 4.68571429 0 4.68571429 3.12866817 4 3.12866817" />
          </g>
        </g>
      </g>
    </svg>
    );
  }
}


sendTranscript.displayName = 'sendTranscript';
sendTranscript.propTypes = {
  onSendTranscript: React.PropTypes.func
};

export default sendTranscript;



// WEBPACK FOOTER //
// ./src/components/SendTranscript.js